<template>
    <div class="psetinfo">
		<div>
			<div style="height: .3rem"></div>
			<div class="psetinfo-title">
				<p>
					提示：您是首次进行脑能力检测用户，为了检测的结果更加准确，请您完善以下基本信息！
				</p>
			</div>
			<div class="psetinfo-from">
				<el-form class="demo-ruleForm" :model="userInfomation" :rules="rules" ref="userInfomation" label-width="90px" label-position="top">
					<!-- 第一行开始 -->
					 <el-row >
						<el-col>
							<el-form-item label="姓名："  prop="userName">
								<el-input v-model="userInfomation.userName" :maxlength="10" :value="userInfomation.userName"></el-input>
							</el-form-item>
						</el-col>
						<el-col>
							  <el-form-item label="性别：">
								<div class="sexlist">
									<span @touchend="getSex(0)" :class="userSex==0?'isActive':''">男</span>
									<span @touchend="getSex(1)" :class="userSex==1?'isActive':''">女</span>
								</div>
							</el-form-item>  
						</el-col>
					</el-row> 
					<!--第一行结束 -->
					<!--第二行开始 -->
					  <el-row>
						<el-col>
							 <el-form-item label="身份证号："  prop="userCard">
								<el-input v-model="userInfomation.userCard" :maxlength="18" :value="userInfomation.userCard"></el-input>
							</el-form-item> 
						</el-col>
						<el-col>
							 <el-form-item label="出生年月：" prop="userBirthday">
								 <el-date-picker type="month" placeholder="选择日期" default-value="1990" style="width: 100%;" :picker-options="pickerOptions0" v-model="userInfomation.userBirthday" @change="dataFormt">
								</el-date-picker> 
							</el-form-item> 
						</el-col>
					</el-row>  
					<!--第二行结束 -->
					<!-- 第三行开始 -->
					 <el-row>
						<el-col>
							 <el-form-item label="职业：" prop="userJobs">
								 <el-select placeholder="请选择" v-model="userInfomation.userJobs">
									<el-option v-for="item in loadUserProfessional" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select> 
							</el-form-item> 
						</el-col>
						<el-col>
							<el-form-item label="教育程度" prop="userEducation">
								 <el-select placeholder="请选择" v-model="userInfomation.userEducation">
									<el-option v-for="item in loadUserEducationList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select> 
							</el-form-item>
						</el-col>
					</el-row> 
					<!--第三行结束-->
					<!-- 第四行开始 -->
					 <el-row>
						<el-col>
							<el-form-item label="现居住地" prop="userLives">
								 <el-select placeholder="请选择" v-model="userInfomation.userLives">
									<el-option v-for="item in loadUserLiveList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select> 
							</el-form-item>
						</el-col>
					</el-row> 
					<!--第四行结束-->
					<!--第五行开始-->
					<el-row>
						<el-col>
							<el-form-item label="健康状况">
								<div class="healthList" id="content">
									<span v-for="(item,index) in loadUserHealthList" :data-num="index + 1" @touchend="check(index, $event.target)">{{item.name}}</span>
								</div>
								<input type="text" class="isnone" id="inp" />
							</el-form-item>
						</el-col>
					</el-row>
					<!--第五行结束-->
					<!--over button-->
					<el-button class="buttons"  @click="saveInfo('userInfomation')">保存</el-button>
					<!--over button-->
				</el-form>
			</div>
			<div style="height: .7rem"></div>
		</div>
        <myheader :name = "userName" ref="pheader"></myheader>
    </div>
</template>
<script>
	import myheader from "@/phonecomponents/pheader";
	const components = {
		myheader
	}
	export default {
		components: components,
		data(){
			var checkBirthday = (rule, value, callback) => {
				setTimeout(() => {
						if (!value) {
							return callback(new Error('日期不能为空'));
						} else {
							callback();
						}
					}, 1000);
				};
			var isIDCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
			var checkCard = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('身份证号不能为空'));
				}
				setTimeout(() => {
					if (!isIDCard.test(value)) {
						callback(new Error('身份证号格式错误'));
					} else {
						callback();
					}
				}, 1000);
			};
			return {
				myIScroll: null,
				userName: null,
				userInfomation: {
					userName: '',
					userCard: '',
					userBirthday: '',
					userEducation: '',
					userLives: '',
					userJobs: '',
				},
				rules: {
					userName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'change'
					}],
					userCard: [{
						required: true,
						validator: checkCard,
						trigger: 'blur'
					}],
					userBirthday: [{
						required: true,
						validator: checkBirthday,
						trigger: 'change'
					}],
					userJobs: [{
						type: 'number',
						required: true,
						message: '请选择职业',
						trigger: 'blur'
					}],
					userEducation: [{
						type: 'number',
						required: 'true',
						message: '请选择教育程度',
						trigger: 'blur'
					}],
					userLives: [{
						type: 'number',
						required: true,
						message: '请选择居住地址',
						trigger: 'blur'
					}]
				},
				pickerOptions0: {
					disabledDate(time) {
						return time.getTime() > new Date('2000,12,12,00:00:00').getTime() || time.getTime() < new Date('1899,12,12,00:00:00').getTime();;
					}
				},
				userSex: 0,
				loadUserHealthList: null,
				userHealth: [],
				userHealthStr: '',
				loadUserEducationList: null,
				loadUserProfessional: null,
				loadUserLiveList: null,
				isShowInput: false,
				qita: ''
			}
		},//data
		methods: {
			dataFormt: function(val) {
				this.userInfomation.userBirthday = val
			},
			getSex(ind){
				this.userSex = ind;
				console.log(this.userSex)
			},
			currentClass (content, style) {
                for (var j = 1; j < content.children.length; j++) {
                    content.children[j].className = style;
                }
            },
            check (ind, ev) {
                var active =  ev.getAttribute('data-num');
                var content = document.querySelector('#content');
                var inp = document.querySelector('#inp');
				var disStyle = -1;
                if (+active === 1) {
                    if (ev.className === 'blue') {
                        ev.className = 'ospan';
                        this.currentClass(content, 'ospan');
                    } else {
						ev.className = 'blue';
						inp.className = 'isnone';
                        this.currentClass(content, 'ospan');
                    }
                }
                if (+active !== 1) {
                    if (ev.className === 'blue') {
                        ev.className = 'ospan';
                        if (+active === 10) {
                            inp.className = 'isnone';
                        }
                        for (var j = 1; j < content.children.length; j++) {
                            if (content.children[j].className === 'blue') {
                                disStyle = 1;
                            }
                        }
                        if (disStyle !== 1) {
                            content.children[0].className = 'ospan';
                        }
                    } else {
                        ev.className = 'blue';
                        if (+active === 10) {
                            inp.className = 'isblock';
                        }
                        content.children[0].className = 'ospan';
                    }
                }
            },
            submit () {
                var content = document.querySelector('#content');
                var str = '';
                for (var j = 0; j < content.children.length; j++) {
                    if (content.children[j].className === 'blue') {
                        str += content.children[j].getAttribute('data-num') + ',';
                    }
                }
                var reg = /,$/;
				str = str.replace(reg, '');
				this.userHealthStr = str;
			},
			saveInfo(formName) {
				this.submit ()
				console.log(this.userHealthStr)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$http.post(urls.urltest + "/personal/updateMyInfo", {
							token: localStorage.getItem('token'),
							name: this.userInfomation.userName,
							sex: this.userSex,
							cardnumber: this.userInfomation.userCard,
							birthday: this.userInfomation.userBirthday,
							professional: this.userInfomation.userJobs,
							education: this.userInfomation.userEducation,
							live: this.userInfomation.userLives,
							health: this.userHealthStr,
							id: localStorage.getItem('userID'),
						}).then(function(res) {
							localStorage.setItem("userName", this.userInfomation.userName);
							if (res.body = 1) {
								console.log(res.body)
								this.userName = this.userInfomation.userName;
								this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
								this.$message({
									message: '修改成功',
									type: 'success'
								});
							} else {
								this.$message({
									message: '修改失败',
									type: 'error'
								});
							}
						})
					} else {
						this.$message({
									message: '请填写基本信息',
									type: 'error'
								});
						return false;
					}
				});
			 }
		},//methods
		created () {
			/* 用户信息回显 */
			var _this = this;
			setTimeout(function() {
				_this.$http.post(urls.urltest + "/personal/getUserInfo.json", {
					token: localStorage.getItem('token')
				})
				.then(function(res) {
					console.log(res.body)
					_this.userInfomation.userName = res.body.object.username  
					localStorage.setItem("userID", res.body.object.id);
					_this.userSex = res.body.object.sex
					_this.userInfomation.userCard = res.body.object.cardnumber
					_this.userInfomation.userJobs = res.body.object.professional
					_this.userInfomation.userBirthday = res.body.object.birthday
					_this.userInfomation.userEducation = res.body.object.education
					_this.userInfomation.userLives = res.body.object.live
					_this.userHealthStr = res.body.object.health
					console.log(_this.userHealthStr)
					var content = document.querySelector('#content');
					for (var j = 0; j < content.children.length; j++) {
						//console.log(content.children[j].getAttribute('data-num'))
						for(var i=0;i<_this.userHealthStr.length;i++){
							if(_this.userHealthStr[i] == content.children[j].getAttribute('data-num')){
								content.children[j].className = 'blue'
							}
						}
					}
					
				})
			});
			/* 职业 */
			this.$http.post(urls.urltest + "/api/loadUserProfessional.json", {
				token: localStorage.getItem('token')
			})
			.then(function(res) {
				this.loadUserProfessional = res.body
			})
			/* 教育程度 */
			this.$http.post(urls.urltest + "/api/loadUserEducationList.json", {
				token: localStorage.getItem('token')
			})
			.then(function(res) {
				this.loadUserEducationList = res.body
			})
			/* 现居住地址 */
			this.$http.post(urls.urltest + "/api/loadUserLiveList.json", {
				token: localStorage.getItem('token')
			})
			.then(function(res) {
				this.loadUserLiveList = res.body
			})
			/* 健康状况 */
			this.$http.post(urls.urltest + "/api/loadUserHealthList.json", {
				token: localStorage.getItem('token')
			})
			.then(function(res) {
				this.loadUserHealthList = res.body
			})
		},
		mounted() {
			var _this = this;
			setTimeout(function() {
				_this.myIScroll = new IScroll(".psetinfo", {
					prevenDefault: true
				})
			})
		},
		updated(){
			var _this = this;
			setTimeout(function() {
				_this.myIScroll.refresh();
			})
			
		}
	}
</script>
<style lang="scss">
    @import "../styles/core/reset.scss";
    .psetinfo{
        margin-top: .15rem;
		width: 100%;
		height: 100%;
        .psetinfo-title{
            font-size: .17rem;
            color: #999;
            padding: .2rem 0;
            background: #fff;
            p{
                margin: 0 2%;
            }
        }
        .psetinfo-from{
            background: #fff;
           
            .el-form{
                position: relative;
                .el-row{
                    clear: both;
                    .el-col{
                        clear: both;
                        .el-form-item{
                            clear: both;
                            .el-form-item__label{
                                float: left;
                                margin-left: 2%;
                                font-size: .12rem;
                                color: #555;
                            }
                            .el-form-item__content{
                                clear: both;
                                .el-input{
                                    .el-input__inner{
                                         background: #F4F5F8;
                                         border-radius: .03rem;
                                         border: 1px solid #EEEEEE;
                                         width: 96%;
                                         margin-left: 2%;
                                    }
                                }
                                .el-select{
                                    width: 100%;
								}
								.el-form-item__error {
									color: #ff4949;
									font-size: 0.12rem;
									line-height: 40px;
									position: absolute;
									top: 0;
									right: 18px;
									padding: 0 8px;
									left: auto;
								}
								.sexlist{
									width: 100%;
									@include flexbox;
									span{
										display: block;
										@include flex;
										height: .44rem;
										background: #F4F5F8;
										border: 1px solid #eee;
										text-align: center;
										line-height: .44rem;
										border-radius: .03rem;
										margin: 0 .1rem;
										box-sizing: border-box;	
										&.isActive{
											color: #444;
											border: 1px solid #467DE5;
											border-radius: .03rem;
										}
									}
								}
								.el-radio-group{
									width: 100%;
									@include flexbox;
									.el-radio-button{
										@include flex;
										height: .44rem;
										background: #F4F5F8;
										border: 1px solid #eee !important;
										text-align: center;
										line-height: .44rem;
										border-radius: .03rem;
										margin: 0 .1rem;
										box-sizing: border-box;										
										.el-radio-button__inner{
											border: none;
											background: none;
											width: 100%;
											height: 100%;
											padding: 0;
											line-height: .44rem;
										}
									}
									.is-active{
										border: none !important;
									}
								}
								
                            }
                        }
					}
					.healthList{
						padding: 0 .1rem 1rem .1rem;					
						span,input {
							display: inline-block;
							width: 1.26rem;
							height: .44rem;
							background: #F4F5F8;
							border: 1px solid #EEEEEE;
							border-radius: .03rem;
							text-align: center;
							line-height: .44rem;
							display: inline-block;
							margin: 0 10px 10px 0;
							&.ospan{
								color: #000;
							}
							&.blue{
								background: #467DE5;
								color: #fff;
							}
						}
						input{
							float: left;
						}
					}
					.isnone {
						display: none;
					}
					.isblock {
						display: block;
					}
                }
                .buttons{
                    width: 92%;
                    height: .5rem;
                    color: #fff;
                    background: #467DE5;
                    font-size: .17rem;
                    border: none;
                    border-radius: .05rem;
                    position: fixed;
                    bottom: 1rem;
                    left: 50%;
                    transform: translate(-50%,0);
                }
            }
        }
	}
	.el-radio-button__orig-radio:checked+.el-radio-button__inner{
		color: #444;
		border: 1px solid #467DE5 !important;
		border-radius: .03rem;
		box-shadow: none;
		box-sizing: border-box;	
	}
</style>


// WEBPACK FOOTER //
// setinfo.vue?6b3c2a84